import { gql } from '@apollo/client';

export const GET_SUBJECTS = gql`
  query getSubjects($cohortId: String!) {
    subjects(cohortId: $cohortId) {
      id
      name
      cohortId
    }
  }
`;

/**
 * A subject with its topics. Topics live in a subcollection, so they are
 * fetched alongside rather than nested — `topics` needs the subject id that
 * `subject` was just given.
 */
export const GET_SUBJECT = gql`
  query getSubject($id: String!) {
    subject(id: $id) {
      id
      name
      cohortId
    }
    topics(subjectId: $id) {
      id
      topicNo
      title
      status
      createdAt
      updatedAt
    }
  }
`;

/** The caller's own enrolments. Replaces `userSubjects(where:)`. */
export const GET_USER_SUBJECT = gql`
  query getMySubjects {
    mySubjects {
      id
      name
      cohortId
    }
  }
`;
